// extracted by mini-css-extract-plugin
module.exports = {"checkinList":"Home_checkinList__2vLyG","checkinList__text":"Home_checkinList__text__3-r6P"};